import ResponsiveWrapper from 'components/shared/others/responsive-wrapper/responsive-wrapper';
import Heading from 'components/partials/heading/heading';
import Loader from 'components/partials/loader/loader';
import EmptySpaceContent from 'components/partials/empty-space-content/empty-space-content';

import InsightItem from 'containers/user/insights/insight-item';
import useInsights from 'containers/user/insights/use-insights';

import Icons from 'assets/icons';

const Insights = (): React.JSX.Element => {
  const { loading, insights } = useInsights();

  return (
    <ResponsiveWrapper customClass="mt-8">
      <Loader loading={loading} fullScreen={false} />
      <div className="flex items-center mb-6 gap-4 mobile:justify-center tablet:justify-start">
        <Heading variant="h2">Insights</Heading>
      </div>

      {!loading && insights.length === 0 ? (
        <EmptySpaceContent
          image={<Icons.EmptyImage customClass="w-[210px] h-[210px]" />}
          text="No insights have been shared yet"
        />
      ) : (
        <div className="flex flex-wrap gap-4 mt-4 mobile:justify-center tablet:justify-start">
          {insights.map((insight) => (
            <InsightItem key={insight.id} insight={insight} />
          ))}
        </div>
      )}
    </ResponsiveWrapper>
  );
};

export default Insights;
